import React, { Component } from "react";
import MessageBoardAdmin from "./MessageBoardAdmin";
import MessageBoardFeedView from "./MessageBoardFeedView";
import AllAnswersView from "./AllAnswersView";

export default class MessageBoardFeatureSelector extends Component {
  state = {
    view: "ManageQuestions", // "ManageQuestions" or "ViewFeed"
  };

  renderView() {
    switch (this.state.view) {
      case "ManageQuestions":
        return <MessageBoardAdmin />;
      case "ViewFeed":
        return <MessageBoardFeedView />;
      case "ViewAllAnswers":
        return <AllAnswersView />;
      default:
        return <MessageBoardAdmin />;
    }
  }

  render() {
    const activeButtonStyle = {
      fontSize: "20px",
      border: "3px solid #00d1b2", // Bulma primary color, or your preference
      color: "#00d1b2",
      background: "white",
      borderRadius: "12px",
      padding: "5px 10px",
    };

    const inactiveButtonStyle = {
      fontSize: "20px",
      border: "1px solid #dbdbdb",
      color: "#363636",
      background: "white",
      borderRadius: "12px",
      padding: "5px 10px",
      marginLeft: "10px",
    };

    const getButtonStyle = (viewName) => {
      let style =
        this.state.view === viewName ? activeButtonStyle : inactiveButtonStyle;
      // Adjust margin for the first button
      if (
        viewName === "ManageQuestions" &&
        this.state.view !== "ManageQuestions"
      ) {
        style = { ...style, marginLeft: "0px" };
      } else if (
        viewName === "ManageQuestions" &&
        this.state.view === "ManageQuestions"
      ) {
        style = { ...style, marginLeft: "0px" };
      }
      return style;
    };

    return (
      <>
        <section className="section">
          <div className="container">
            <h1 className="title is-3">Message Board Admin & Feed</h1>
            <p className="subtitle is-5">
              Manage questions or view the user feed for testing.
            </p>
            <br />
            <div className="buttons has-addons mb-5">
              <button
                style={getButtonStyle("ManageQuestions")}
                onClick={() => this.setState({ view: "ManageQuestions" })}
              >
                Manage Questions
              </button>
              <button
                style={getButtonStyle("ViewFeed")}
                onClick={() => this.setState({ view: "ViewFeed" })}
              >
                View Feed (Test)
              </button>
              <button
                style={getButtonStyle("ViewAllAnswers")}
                onClick={() => this.setState({ view: "ViewAllAnswers" })}
              >
                View All Answers
              </button>
            </div>
            {this.renderView()}
          </div>
        </section>
      </>
    );
  }
}
